/**
 * Created by d.penning on 05.10.2017.
 */
import { CHANGE_CHANNEL } from './actionTypes'

export const changeChannel = (id: any) => ({
    type: CHANGE_CHANNEL,
    id,
})
